<div class="container">
  <div class="top-section">
    <h2 *ngIf="currentView === 'transfers'" class="content-header mat-headline">
      {{ "TransferHistoryTable.TransferHistory" | translate }}
    </h2>
    <h2 *ngIf="currentView === 'receipts'" class="content-header mat-headline">
      {{ "TransferHistoryTable.ReceiptHistory" | translate }}
    </h2>
    <div class="search-container">
      <mat-menu #menu="matMenu">
        <button (click)="downloadPDF()" mat-menu-item>
          {{ "Export.PDF" | translate }}
        </button>
      </mat-menu>
      <button
        [disabled]="loading || transactionHistory.data.length === 0"
        [matMenuTriggerFor]="menu"
        mat-icon-button
      >
        <mat-icon>file_download</mat-icon>
      </button>
      <img
        hidden
        aria-hidden="false"
        aria-label="filter icon"
        svgIcon="filter"
        src="../../../../../assets/Icons/filter.svg"
        alt="filter-icon"
      />
      <div id="search-input">
        <input
          (input)="applyFilter($any($event.target).value)"
          type="text"
          matTooltip="{{ 'TransferHistoryPage.SearchToolTip' | translate }}"
        />
        <mat-icon aria-hidden="false" aria-label="magnifier icon" id="magnifier"
          >search</mat-icon
        >
      </div>
    </div>
  </div>
  <div class="test mat-elevation-z8">
    <mat-progress-bar
      *ngIf="loading"
      color="primary"
      mode="indeterminate"
    ></mat-progress-bar>
    <table
      mat-table
      [dataSource]="transactionHistory"
      matSort
      (matSortChange)="sortChanged($event)"
      class="mat-elevation-z8"
      id="transfer_history_data_table"
    >
      <!-- Date Column -->
      <ng-container matColumnDef="{{ displayedColumns[0] }}">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by 'displayedColumns[0]'"
        >
          {{ "TransferHistoryTable.TransferDate" | translate }}
        </th>
        <ng-container *matCellDef="let element">
          <td mat-cell *ngIf="localDateFormat === 'en-US'">
            {{ element.date | date: "M/dd/yyyy" }}
          </td>
          <td mat-cell *ngIf="localDateFormat !== 'en-US'">
            {{ element.date | date: "yyyy/M/dd" }}
          </td>
        </ng-container>
      </ng-container>

      <!-- To or From Column -->
      <ng-container matColumnDef="{{ displayedColumns[1] }}">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{
            (displayedColumns[1] === "to"
              ? "TransferHistoryTable.TransferTo"
              : "TransferHistoryTable.TransferFrom"
            ) | translate
          }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ displayedColumns[1] === "to" ? element.to : element.from }}
        </td>
      </ng-container>

      <!-- Product Type Column -->
      <ng-container matColumnDef="{{ displayedColumns[2] }}">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "TransferHistoryTable.TransferProductType" | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.productType }}
        </td>
      </ng-container>

      <!-- Quantity Column -->
      <ng-container matColumnDef="{{ displayedColumns[3] }}">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "TransferHistoryTable.TransferQuantity" | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.quantity }}</td>
      </ng-container>

      <!-- Total Active Column -->
      <ng-container matColumnDef="{{ displayedColumns[4] }}">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "TransferHistoryTable.TransferTotalActive" | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.totalActive }}</td>
      </ng-container>

      <!-- Purchase Order Column -->
      <ng-container matColumnDef="{{ displayedColumns[5] }}">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "TransferHistoryTable.TransferPurchaseOrder" | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.purchaseOrder }}</td>
      </ng-container>

      <!-- Notes Column -->
      <ng-container matColumnDef="{{ displayedColumns[6] }}">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "TransferHistoryTable.TransferNotes" | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.notes }}</td>
      </ng-container>

      <ng-container matColumnDef="{{ displayedColumns[7] }}">
        <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
        <td mat-cell *matCellDef="let element">
          <mat-menu #menu="matMenu">
            <button mat-menu-item>
              {{ "Export.PDF" | translate }}
            </button>
          </mat-menu>
          <button mat-button [matMenuTriggerFor]="menu" mat-icon-button>
            <mat-icon>more_vert</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    <mat-paginator
      [length]="totalRows"
      [pageIndex]="currentPage"
      [pageSize]="pageSize"
      (page)="pageChanged($event)"
      [pageSizeOptions]="[5, 10, 20]"
      showFirstLastButtons
      aria-label="Select page of transaction history"
    >
    </mat-paginator>
  </div>
</div>

<app-credits-transfer-failure
  [requestType]="'transactionHistory'"
  (togglePopUp)="togglePopup()"
  (tryAgainHandler)="requestTransactionHistoryData()"
  *ngIf="showError"
></app-credits-transfer-failure>
